export const initialState = {
  isAuthenticated: false,
  isLoading: true
};
